<div class="header">
	<h3 data-cy="webviewer-preview-heading"><i class="fal fa-arrow-up-right-from-square"></i>
		{{ "WebViewers" | translate }} ({{webviewers.length}})
	</h3>

	<div class="selection">
		<mat-form-field subscriptSizing="dynamic">
			<mat-label>{{ "WebViewerName"| translate }}</mat-label>
			<mat-select data-cy="webviewer-selection" (selectionChange)="onSelectionChange($event.value)"
				[compareWith]="compareWebviewers" [(ngModel)]="selectedWebviewer">
				<mat-option *ngFor="let webviewer of webviewers" [value]="webviewer">
					{{webviewer.name}}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</div>

<mat-card>
	<mat-card-content>
		<iframe [src]="sanitizedAppUrl" #webviewerIframe c>
		</iframe>

		<div class="url-wrapper">
			<mat-label data-cy="webviewer-preview-selected-url">URL: {{selectedWebviewer.url}}</mat-label>
			<button mat-raised-button color="primary" ngxClipboard [cbContent]="selectedWebviewer.url">
				<i class="fal fa-sign-in-alt"></i> {{'Zwischenablage' | translate}}
			</button>
		</div>
	</mat-card-content>
</mat-card>

<div class="related-data">
	<!-- Related Messages -->
	@if (relatedMessages$ | async; as relatedMessages) { @if(relatedMessages.length) {
	<mat-card class="related-messages">
		<mat-card-content>
			<h3>{{ 'WebViewerRelatedMessages' | translate }}</h3>

			<table mat-table [dataSource]="relatedMessages" class="messages-table">
				<!-- Date Column -->
				<ng-container matColumnDef="date">
					<td mat-cell *matCellDef="let msg" class="single-line">
						{{msg.created | date:dateFormat}}
					</td>
				</ng-container>

				<!-- Icons Column -->
				<ng-container matColumnDef="icons">
					<td mat-cell *matCellDef="let msg"
						[ngStyle]="{'text-align': isStaffMemberMessage(msg) ? 'right' : 'left'}"
					>
						<i class="{{MessageTypeIcons[msg.type].icon}}"
							[ngClass]="{'fa-flip-horizontal': (isStaffMemberMessage(msg) && msg.type === MessageTypes.Note)}"
						></i>
					</td>
				</ng-container>

				<!-- Sender Column -->
				<ng-container matColumnDef="sender">
					<td mat-cell *matCellDef="let msg">
						<span>{{sendersTypeLabel(msg.sendersType)}}</span>
					</td>
				</ng-container>

				<!-- Message Column -->
				<ng-container matColumnDef="message">
					<td mat-cell *matCellDef="let msg" [innerHtml]="msg.message"
						[ngClass]="{'staff-message': isStaffMemberMessage(msg)}"
					></td>
				</ng-container>

				<tr mat-row *matRowDef="let row; columns: ['date', 'icons', 'sender', 'message'];"></tr>
			</table>
		</mat-card-content>
	</mat-card>
	}}

	<!-- Related Media -->
	@if (relatedMedia$ | async; as relatedMedia) { @if (relatedMedia.length){
	<mat-card class="related-media">
		<mat-card-content>
		<h3>{{ 'WebViewerRelatedMedia' | translate }}</h3>
		<table mat-table [dataSource]="relatedMedia" class="media-table">
			<!-- Filename Column -->
			<ng-container matColumnDef="filename">
				<td mat-cell *matCellDef="let media" title="{{media.orgFilename}}">
					{{ media.orgFilename | cutFileName:79 }}
				</td>
			</ng-container>

			<!-- Filetype Column -->
			<ng-container matColumnDef="filetype">
				<td mat-cell *matCellDef="let media">
					{{ media.filetype | uppercase }}
				</td>
			</ng-container>

			<!-- Filesize Column -->
			<ng-container matColumnDef="filesize">
				<td mat-cell *matCellDef="let media">
					{{ getFileSizeKb(media.filesize) }} KB
				</td>
			</ng-container>

			<!-- Actions Column -->
			<ng-container matColumnDef="actions">
				<td mat-cell *matCellDef="let media">
					<a (click)="downloadMediaFile(media._id)">
						<i class="fal fa-download"></i>
					</a>
				</td>
			</ng-container>

			<tr mat-row *matRowDef="let row; columns: ['filename', 'filetype', 'filesize', 'actions'];"></tr>
		</table>
	</mat-card-content>
	</mat-card>
	}}
</div>
